import type { HelpFile } from '../../types/help'
import { DragHandleTestIds } from '../../../testids/DragHandleTestIds'

export const dragHandleHelp: HelpFile = {
  texts: {
    [DragHandleTestIds.dragRow42]:
      'Grip handle — drag this row to reorder it within the list.',
  },
}
